import Link from "next/link";

import CloseCross from "@catchy/assets/svgs/close-cross.svg";
import ExternalLink from "@catchy/assets/svgs/external-link.svg";

import IconButton from "./IconButton";

const URL_REGEX = /(https?:\/\/[^\s<]+)/g;

function formatAlertText(text) {
  if (typeof text !== "string" || !text.trim()) {
    return null;
  }

  return text
    .trim()
    .split(/\r\n|\r|\n/)
    .map((line, i) => {
      const words = line.split(URL_REGEX);
      return (
        <p key={i}>
          {words.map((word, j) => {
            if (word.match(URL_REGEX)) {
              return (
                <Link
                  key={j}
                  href={word}
                  className="font-semibold underline decoration-zinc-900/30 decoration-1 underline-offset-2 dark:decoration-white/30"
                >
                  {word}
                </Link>
              );
            }
            return word;
          })}
        </p>
      );
    });
}

const Alert = ({
  alert_id,
  severity_level,
  header_text,
  description_text,
  url,
  dismissable = false,
  dismissedAlerts = [],
  setDismissedAlerts,
}) => (
  <div
    className={`relative mx-[20px] flex flex-row rounded-lg p-4 ring-2 ring-inset ${
      severity_level === "INFO"
        ? "bg-blue-50 p-4 ring-2 ring-inset ring-blue-300 dark:bg-blue-800 dark:ring-blue-900"
        : "bg-rose-50 ring-rose-300 dark:bg-rose-800 dark:ring-rose-900"
    }`}
  >
    <div className="flex w-full flex-col gap-y-2">
      {description_text && (
        <h2
          className={`text-pretty text-lg font-bold leading-5 ${dismissable ? "pr-8" : ""}`}
        >
          {header_text}
        </h2>
      )}
      <div
        className={`flex flex-col gap-y-2 leading-tight ${
          !description_text ? "pr-8" : ""
        }`}
      >
        {formatAlertText(description_text || header_text)}
      </div>
      {url && (
        <div className="w-full">
          <Link
            href={url}
            target="_blank"
            className="flex items-start text-blue-500 dark:text-white"
          >
            <ExternalLink className="mr-2 mt-1 inline-block h-3 w-3 shrink-0" />
            <div className="flex flex-wrap leading-tight">
              <span className="mr-1 shrink-0 font-semibold">
                More information
              </span>
              <span>({new URL(url).hostname})</span>
            </div>
          </Link>
        </div>
      )}
    </div>
    {dismissable && (
      <IconButton
        label="Dismiss alert"
        variant="subtle"
        onClick={() => setDismissedAlerts([alert_id, ...dismissedAlerts])}
        className="absolute right-2 top-2"
      >
        <CloseCross
          className="h-[0.8125rem] w-[0.8125rem]"
          aria-hidden="true"
        />
      </IconButton>
    )}
  </div>
);

export default Alert;
